import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import { resTransform } from './transforms';

const { baseUrl } = config;

export const fetchList = async (params = {}) => {
  try {
    const url = `${baseUrl}/BioFuelRegistration/api/BusinessProfile/FetchAllBanks`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchList(resData);
  } catch (err) {
    console.log('FetchAllBanks->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'FetchAllBanks');
    throw errors;
  }
};
